
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><MDXTag name="h1" components={components} props={{"id":"라이브러리-개발에-참여하기"}}>{`라이브러리 개발에 참여하기`}</MDXTag>
<MDXTag name="h2" components={components} props={{"id":"css-파일을-작성하고-사용할-때-주의사항"}}>{`css 파일을 작성하고 사용할 때 주의사항`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="inlineCode" components={components} parentName="p">{`@devsisters/ui-*`}</MDXTag>{`를 사용하는 프로젝트에서
css loader 설정을 자유롭게 사용할 수 있도록 하기 위해서
라이브러리에서는 약간의 제약사항을 지켜서 css 규칙을 작성하도록 합니다.`}</MDXTag>
<MDXTag name="ul" components={components}>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`.module.scss`}</MDXTag>{` 확장자 사용하기`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`lib`}</MDXTag>{` 폴더에 `}<MDXTag name="inlineCode" components={components} parentName="li">{`.module.css`}</MDXTag>{` 파일로 빌드됩니다.`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul">{`따라서 해당 css 파일을 사용하는 같은 경로의 `}<MDXTag name="inlineCode" components={components} parentName="li">{`컴포넌트.tsx`}</MDXTag>{`에서는`}<br/>
<MDXTag name="inlineCode" components={components} parentName="li">{`import * as styles from './파일이름.module.css';`}</MDXTag>{`이렇게 import 해주어야 합니다.`}</MDXTag>
</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`.module.css`}</MDXTag>{` 확장자를 사용하는 이유는 Create React App, GatsbyJS 등에서
기본적으로 해당 확장자에 대해서는 css module임을 가정하기 때문입니다.`}</MDXTag>
</MDXTag></MDXTag>
<MDXTag name="li" components={components} parentName="ul">{`id 셀렉터, class 셀렉터는 `}<MDXTag name="inlineCode" components={components} parentName="li">{`:local()`}</MDXTag>{`로 감싸주기`}<MDXTag name="ul" components={components} parentName="li">
<MDXTag name="li" components={components} parentName="ul"><MDXTag name="inlineCode" components={components} parentName="li">{`.module.css`}</MDXTag>{` 확장자를 사용할 것이기 때문에 이렇게까지 할 필요성은 좀 떨어지지만,`}<br/>{`
혹여나 css modules 설정을 해놓지 않은 프로젝트에서도 문제없이 돌아가도록 하기 위함입니다.`}</MDXTag>
</MDXTag></MDXTag>
</MDXTag>
           </MDXTag>
  }
}
  